
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'
import { M } from './_elementComps/M'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Eine ganze Menge: sich informieren, Buch führen und die Signale beachten, die
der Körper gibt. Wichtig ist, über einige Monate einen Kopfschmerzkalender zu
führen und jeden Anfall zu protokollieren, insbesondere vor Arztbesuchen. Solche
Kalender gibt es auch als App (zum Beispiel die `}<Link href='https://schmerzklinik.de/die-migraene-app/' iconSize='small' mdxType="Link">{`Migräne-App`}</Link>{`
der Schmerzklinik Kiel oder `}<Link href='https://m-sense.de/' iconSize='small' mdxType="Link">{`M-sense`}</Link>{`) oder zum
Ausdrucken (beispielsweise `}<Link href='https://schmerzklinik.de/wp-content/uploads/2009/02/schmerzkalender_schmerzklinik_kiel.pdf' iconSize='small' mdxType="Link">{`hier`}</Link>{`).
Ausserdem braucht es Geduld, um den mittelfristigen Erfolg einer Behandlung
beurteilen zu können – und die fehlt vielen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;